'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Pace = function (_Component) {
  _inherits(Pace, _Component);

  function Pace() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Pace);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pace.__proto__ || Object.getPrototypeOf(Pace)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      width: 0
    }, _this.getStyles = function () {
      var styles = {
        main: {
          height: _this.props.height || 10,
          backgroundColor: _this.props.color || '#2c3e50',
          transition: 'width 0.5s',
          width: Math.floor(_this.state.width * 100) + '%'
        },
        container: {
          position: 'absolute',
          width: '100%'
        }
      };

      if (_this.props.style) {
        styles.main = Object.assign({}, _this.props.style, styles.main);
      }

      return styles;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Pace, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.intervalId = setInterval(function () {
        _this2.setState({
          width: _this2.state.width + (1 - _this2.state.width) * 0.25
        });
      }, 500 + 200 * Math.random());
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.intervalId);
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = this.getStyles();
      var _props = this.props,
          id = _props.id,
          className = _props.className;
      return _react2.default.createElement('div', {
        style: styles.container
      }, _react2.default.createElement('div', _extends({
        id: id,
        className: className
      }, {
        style: styles.main
      })));
    }
  }]);

  return Pace;
}(_react.Component);

Pace.propTypes = {
  height: _propTypes2.default.number,
  color: _propTypes2.default.string,
  style: _propTypes2.default.object,
  id: _propTypes2.default.string,
  className: _propTypes2.default.string
};
exports.default = Pace;
module.exports = exports['default'];